const pagePattern = /page=([0-9])*/;
const itemsPerPagePattern = /PS=[0-9]*/;
const subSearchPattern = /ss=[^&]*/;
const productQuantityPattern = /\/mq\/[0-9]*/;
const sortByPattern = /fs=[^&]*&csd=(ASC|DESC)/;
const pricePattern = /\/p\/[0-9]*-[0-9]*/;
const colorPattern = /\/c\/[0-9-]*/;
const ratingPattern = /\/r\/[0-5-]*/;
const prodTimePattern = /\/s\/[0-9]*/;
const imprintLocationCountPattern = /\/l\/[0-9]*/;
const imprintColorCountPattern = /\/m\/[0-9]*/;
const tagPattern = /\/t\/[0-9-]*/;
const paramPattern = /\/[cprlmst]\/[0-9]/;

const sortMap = [{ v: "string:-RelevenceScore", q: "fs=Relevance&csd=DESC", meta: "" },
{ v: "string:SellPrice1", q: "fs=LowestSellPrice&csd=ASC", meta: "Price Low-High" },
{ v: "string:-SellPrice1", q: "fs=LowestSellPrice&csd=DESC", meta: "Price High-Low" },
{ v: "string:MinOrderQty", q: "fs=MinOrderQty&csd=ASC", meta: "Minimum Quantity" },
{ v: "string:ProductName", q: "fs=ProductName&csd=ASC", meta: "Product Name" },
{ v: "string:ProductionTime", q: "fs=ProductionTime&csd=ASC", meta: "Production Time" },
{ v: "string:-AverageRating", q: "fs=AverageRating&csd=DESC", meta: "Rating" }];

export default class ProductListValues {
    constructor(itemsPerPage, isUserRegistered) {
        this.pagePattern = pagePattern;
        this.itemsPerPagePattern = itemsPerPagePattern;
        this.subSearchPattern = subSearchPattern;
        this.productQuantityPattern = productQuantityPattern;
        this.sortByPattern = sortByPattern;
        this.pricePattern = pricePattern;
        this.colorPattern = colorPattern;
        this.ratingPattern = ratingPattern;
        this.prodTimePattern = prodTimePattern;
        this.imprintLocationCountPattern = imprintLocationCountPattern;
        this.imprintColorCountPattern = imprintColorCountPattern;
        this.tagPattern = tagPattern;
        this.paramPattern = paramPattern;
        this.sortMap = sortMap;
        this.itemsPerPage = this.getItemsPerPage(itemsPerPage);
        this.isUserRegistered = this.getIsUserRegistered(isUserRegistered);
    }

    replaceCurrentUrl(newUrl, newTitle, newDescription, newKeywords) {
        var old = window.location.href;
        var oldTitle = document.title;
        var oldKeywords = document.querySelectorAll('meta[name="keywords"]')[0] ? document.querySelectorAll('meta[name="keywords"]')[0].getAttribute('content') : '';
        var oldDescription = document.querySelectorAll('meta[name="description"]')[0].getAttribute('content') ?? '';
        var urlArray = old.split('/');
        var prot = urlArray[0];
        var host = urlArray[2];
        var url = prot + '//' + host;

        if ((newUrl.indexOf('?') == 0 && old.indexOf('?') > -1 && old.slice(old.indexOf('?')) != newUrl) || old.replace(url, '') != newUrl) {
            history.pushState({ title: oldTitle, keywords: oldKeywords, description: oldDescription }, '', old);
            history.replaceState({ title: newTitle, keywords: newKeywords, description: newDescription }, '', newUrl);
            document.title = newTitle;
        }
    };

    getItemsPerPage(itemsPerPage) {
        return itemsPerPage || 50;
    }

    getIsUserRegistered(isUserRegistered) {
        return isUserRegistered == "True" ? true : false;
    }
}